import { useServices, useServicesRenewingSoon } from "../../lib/queries";
import { useCockpit } from "../../lib/state";

const STATUS_COLOR: Record<string, string> = {
  healthy: "#7ec699",
  warning: "#d4a04c",
  at_risk: "#cf6679",
  unknown: "var(--plum)",
};

export default function ServicesMini() {
  const { data: services = [] } = useServices();
  const { data: renewing = [] } = useServicesRenewingSoon();
  const openDrawer = useCockpit((s) => s.openDrawer);

  const top = services.slice(0, 5);
  const dueAmount = renewing.reduce((sum, s) => sum + (s.monthly_cost_usd ?? 0), 0);

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-2 pt-2 pb-1">
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Stack
        </span>
        <span
          className="font-eyebrow"
          style={{ fontSize: 10, fontWeight: 700, color: "var(--plum)", opacity: 0.6 }}
        >
          {services.length}
        </span>
      </div>
      <div className="flex flex-col gap-1 px-1">
        {top.map((s) => (
          <button
            key={s.id}
            type="button"
            onClick={() => openDrawer("service", s.id)}
            className="aero-glass aero-glass-tight flex items-center gap-2 px-3 py-1.5 text-left text-xs transition-transform hover:-translate-y-0.5"
            style={{ borderRadius: 12 }}
          >
            <span
              className="glossy-radial-bubble"
              style={{
                width: 8,
                height: 8,
                color: STATUS_COLOR[s.status] ?? "var(--plum)",
              }}
            />
            <span
              className="flex-1 truncate"
              style={{ color: "var(--ink)", fontWeight: 600, fontSize: 12 }}
            >
              {s.name}
            </span>
            {(s.monthly_cost_usd ?? 0) > 0 ? (
              <span
                className="holo-text"
                style={{
                  fontFamily: "Bricolage Grotesque, sans-serif",
                  fontWeight: 800,
                  fontSize: 11,
                  letterSpacing: "0.04em",
                }}
              >
                ${Math.round(s.monthly_cost_usd)}
              </span>
            ) : null}
          </button>
        ))}
      </div>
      {renewing.length > 0 ? (
        <div className="px-2 pt-2">
          <span
            className="glossy-pill glossy-pill--small"
            style={{
              background: "linear-gradient(180deg, #ffd28b, #f5a850)",
              color: "var(--plum)",
              textShadow: "none",
            }}
          >
            ★ {renewing.length} {renewing.length === 1 ? "bill" : "bills"} due · ${Math.round(dueAmount)}
          </span>
        </div>
      ) : null}
    </div>
  );
}
